import { useBreakpointValue } from '@genial/utils';
import { useNavigation } from '@react-navigation/native';
import React, { useState } from 'react';

import { useRecoilQuery } from '../../../../../../hooks/useRecoilQuery';
import { SignedInNavigationScreenNavigationProp } from '../../../../../../routes/types';
import { subscriptionMarketStatusQuery } from '../../../../../../store/subscription/selector';
import {
  SubscriptionCustomerItemProps,
  SubscriptionItemProps,
} from '../../../../../../store/subscription/types';
import { getSubscriptionMarketClosedMessage } from '../../../../constants';

import { SubscriptionCustomerListItemDesktop } from './Desktop';
import { SubscriptionCustomerListItemMobile } from './Mobile';
import { SubscriptionCustomerListItemTablet } from './Tablet';

export interface SubscriptionCustomerListItemReceivedProps {
  subscriptionItem: SubscriptionItemProps;
  subscriptionCustomer: SubscriptionCustomerItemProps;
}

export interface SubscriptionCustomerListItemProps
  extends SubscriptionCustomerListItemReceivedProps {
  onSolicit: () => void;
  isDisabled?: boolean;
  quantity: number;
  setQuantity: (value: number) => void;
  disabledMessage?: string;
}

export const SubscriptionCustomerListItem: React.FC<SubscriptionCustomerListItemReceivedProps> = (
  props
) => {
  const [quantity, setQuantity] = useState(props.subscriptionCustomer.availableQuantity);
  const navigation = useNavigation<SignedInNavigationScreenNavigationProp>();

  const { data, loading } = useRecoilQuery(subscriptionMarketStatusQuery);

  const handleSolicit = () => {
    navigation.navigate('SubscriptionSolicitation', {
      customer: props.subscriptionCustomer,
      subscription: props.subscriptionItem,
      quantity,
    });
  };

  const isDisabled =
    props.subscriptionCustomer.availableQuantity === 0 ||
    props.subscriptionItem.timeLimitType === 'expired' ||
    loading ||
    !data?.isOpen;

  const allProps = {
    ...props,
    onSolicit: handleSolicit,
    quantity,
    setQuantity,
    isDisabled,
    disabledMessage: getSubscriptionMarketClosedMessage(data?.originalData),
  };

  const responsiveItemTable = useBreakpointValue({
    base: <SubscriptionCustomerListItemMobile {...allProps} />,
    sm: <SubscriptionCustomerListItemTablet {...allProps} />,
    lg: <SubscriptionCustomerListItemDesktop {...allProps} />,
  });

  return <>{responsiveItemTable}</>;
};
